import { render, staticRenderFns } from "./materialForm.vue?vue&type=template&id=1a35da27&scoped=true&"
import script from "./materialForm.vue?vue&type=script&lang=js&"
export * from "./materialForm.vue?vue&type=script&lang=js&"
import style0 from "./materialForm.vue?vue&type=style&index=0&id=1a35da27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a35da27",
  null
  
)

export default component.exports